import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Valentina M.',
    text: 'El mejor lugar de Punta Carretas. La atención de Mery es impecable, mis uñas nunca duraron tanto y el ambiente es súper relajante. Un 10.'
  }, {
    name: 'Sofía R.',
    text: 'Fui por un masaje descontracturante y salí renovada. El nivel de profesionalismo se nota desde que cruzás la puerta. Ya agendé mi próximo turno.'
  }, {
    name: 'Camila T.',
    text: 'Me hice el lifting de pestañas y quedé fascinada. El estudio es hermoso, te tratan como una reina y los productos son de primera calidad.'
  }];
  return <section className="py-24 bg-white" data-id="element-273">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274">
        <div className="text-center mb-16" data-id="element-275">
          <h2 className="text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-276">
            Testimonios
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-277">
            Lo que dicen nuestras clientas
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-278">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-cream p-8 rounded-2xl relative" data-id="element-279">
              <div className="flex gap-1 mb-6" data-id="element-280">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-subtlegold text-subtlegold" data-id="element-281" />)}
              </div>
              <p className="text-charcoal-light italic font-light leading-relaxed mb-6" data-id="element-282">
                "{testimonial.text}"
              </p>
              <p className="font-medium text-charcoal" data-id="element-283">{testimonial.name}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}